import axios from "axios";

class BrandService {
  async fetchBrand() {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_URI}/v1/brands/dashboard`);
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default new BrandService();
